// İSG Portal — çalışma zamanı yapılandırması (config-driven, platform-agnostik).
//
// API taban adresi **hardcode edilmez** ve platform-özel okuma (Vite
// `import.meta.env`) shared'da YAPILMAZ — `import.meta` mobilde (Metro/Hermes)
// yoktur. Her uygulama giriş noktasında `configureApiBaseUrl(...)` ile enjekte
// eder: web `import.meta.env.VITE_API_BASE_URL`, mobil Expo `extra`/env. Değer
// verilmezse local backend'in varsayılan portu (http://localhost:5080 —
// launchSettings) kullanılır; böylece geliştirici sıfır yapılandırmayla ayağa
// kalkar, ortam override her zaman mümkündür.
//
// `apiBaseUrl` bir **getter**'dır: API client değeri istek anında (lazy) okur;
// böylece enjeksiyon client örneği kurulduktan sonra da geçerli olur.

const DEFAULT_LOCAL_API = 'http://localhost:5080';

let apiBaseUrl = DEFAULT_LOCAL_API;

/** Sondaki `/`'ları temizler (mutlak URL gövdesi çift `/` istemez). */
function normalizeBaseUrl(raw: string): string {
  return raw.replace(/\/+$/, '');
}

/**
 * API taban adresini enjekte eder (uygulama giriş noktasından, herhangi bir
 * istekten ÖNCE). Boş/tanımsız değer varsayılanı korur.
 */
export function configureApiBaseUrl(url: string | null | undefined): void {
  const trimmed = url?.trim();
  if (trimmed && trimmed.length > 0) {
    apiBaseUrl = normalizeBaseUrl(trimmed);
  }
}

export const config = {
  /** Aktif API taban adresi (istek anında lazy okunur). */
  get apiBaseUrl(): string {
    return apiBaseUrl;
  },
} as const;
